import { cn } from '@/lib/utils'

export const CardLayout: React.FC<{ xl?: boolean; children: React.ReactNode }> = ({ xl = false, children }) => (
  <div
    className={`${
      xl ? 'w-full' : 'w-[80vw] sm:w-[50vw] md:w-[40vw] lg:w-[25vw] xl:w-[25vw] 2xl:w-[30vw]'
    } min-w-[300px] shadow bg-white py-2 px-4 gap-1 flex flex-col rounded-lg hover:border-opacity-100 hover:shadow-lg transition-all duration-300`}
  >
    {children}
  </div>
)

export function CardHeader({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cn('border-b border-gray-200 bg-white p-1 md:p-4 flex flex-row', className)}>{children}</div>
}

export const IconInfo: React.FC<{ icon: React.ReactNode; text: React.ReactNode; label?: React.ReactNode }> = ({ icon, text, label }) => (
  <div className="gap-1 flex flex-row items-center">
    {icon}
    <p className="text-sm font-medium leading-6 text-gray-500">{text}</p>
  </div>
)

export const CardInfo: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="infos h-auto gap-2 py-3 flex flex-col items-start content-start justify-start">{children}</div>
)

export const CardActions: React.FC<{ children: React.ReactNode }> = ({ children }) => <div className="actions py-3 flex flex-row w-full">{children}</div>
